<div class="h-layout w-full pb-md">
  <ng-content select="cft-breadcrumbs,cft-back-button"></ng-content>
</div>
<div class="flex items-center pb-2xl text-primary md:min-h-[50vh] lg:pb-0 xl:min-h-[40vh]">
  <div class="h-layout flex h-full w-full flex-col items-center lg:flex-row lg:gap-3xl">
    <div class="w-full lg:w-7/12">
      <!-- title, subtitle container-->
      <div class="mb-2xl flex grow flex-col pt-xl lg:pt-3xl lg:pr-2xl">
        <h1 class="heading-2xl md:heading-4xl">
          {{ content.title | bgoReplaceProps: content.titleProps }}
        </h1>
        @if (content.subtitle) {
          <h2 class="pt-sm text-base leading-default font-medium">
            {{ content.subtitle | bgoReplaceProps: content.subtitleProps }}
          </h2>
        }
      </div>
      <!--      selling point bar-->
      @if (content.isSellingPointBarShown) {
        <div class="flex w-full items-center pb-lg">
          <ng-content select="cft-list-carousel"></ng-content>
        </div>
      }
    </div>
    <div class="relative flex max-h-[350px] w-full items-center justify-center lg:w-5/12">
      <ng-content select="[content=pd-box]"></ng-content>
      <img
        class="-z-10 max-h-fit scale-150 overflow-visible object-contain lg:scale-125 lg:object-cover"
        alt=""
        ngSrc="../../../../../../assets/images/backgrounds/background_offering_directory_default.jpg"
        fill
      />
    </div>
  </div>
</div>
